
import { onMounted, ref } from '@nuxtjs/composition-api';

export default {
  setup() {
    const timeout = ref(2000);
    const notificationAvailable = ref(false)
    const notificationMessage = ref(false)
    onMounted(() => {
      $nuxt.$on('notificationSnackbar', ($event) => {
        notificationMessage.value = $event
        notificationAvailable.value = true
      })
    })
    return {
      timeout,
      notificationAvailable,
      notificationMessage
    }
  }
}
